const envVars = process.env;

const env = (value: string): string => {
  const key = `REACT_APP_${value}`;
  if (!(key in envVars) || !envVars[key]) {
    throw new Error(`no env config found for ${value}`);
  }
  return envVars[key] as string;
};

export default env;
